<template>
  <section class="livratos-double-section">
    <div class="container">
      <h3 class="mb-4">Plus de détail&nbsp;?</h3>

      <!-- Étape 1 : Inscription -->
      <div class="livratos-row">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/register-livreur.webp"
              alt="Inscription du livreur sur la plateforme Livratos"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 1 • Inscription</p>
            <h2>
              Créez votre profil<br />
              livreur Livratos
            </h2>
            <p>
              Vous remplissez votre profil en ligne&nbsp;: identité, structure
              (indépendant ou société), type(s) de véhicule, zones
              d’intervention et coordonnées bancaires. Quelques minutes
              suffisent pour poser les bases de votre activité dans l’écosystème
              Livratos.
            </p>
            <ul class="features-list">
              <li>
                Formulaire pensé pour les
                <strong>livreurs BTP</strong> (fourgon, plateau, poids lourd,
                utilitaire…).
              </li>
              <li>
                Ajout de plusieurs véhicules possibles au sein du même profil.
              </li>
              <li>
                Définition de vos zones habituelles et de vos disponibilités.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Étape 2 : Activation du compte -->
      <div class="livratos-row reverse">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/document-livreur.webp"
              alt="Validation du profil livreur par l’équipe Livratos"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 2 • Activation</p>
            <h2>
              Validation de vos documents,<br />
              profil prêt à recevoir des missions
            </h2>
            <p>
              Nos équipes contrôlent vos pièces (identité, permis, assurances,
              éventuel Kbis) et valident votre éligibilité. Nous paramétrons les
              types de courses qui correspondent à votre véhicule et à votre
              statut, pour que les <strong>livraisons</strong> proposées soient
              cohérentes avec votre activité réelle.
            </p>
            <ul class="features-list">
              <li>
                Vérification administrative et conformité avec la réglementation
                transport.
              </li>
              <li>
                Paramétrage des missions accessibles selon véhicule et zone.
              </li>
              <li>
                Support de démarrage si besoin pour prendre en main l’interface.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Étape 3 : Prise de courses -->
      <div class="livratos-row">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/use-livreur.webp"
              alt="Prise de missions par le livreur dans Livratos"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 3 • Prise de courses</p>
            <h2>
              Choisissez vos livraisons,<br />
              en fonction de vos contraintes
            </h2>
            <p>
              Une fois votre profil activé, vous voyez les missions compatibles
              avec votre véhicule et votre zone. Pour chaque
              <strong>livraison</strong>&nbsp;: point de retrait,
              <strong>chantier</strong> de destination, créneau, type de
              chargement et contraintes d’accès sont indiqués avant d’accepter.
              Vous gardez la main sur ce que vous prenez, quand vous le prenez.
            </p>
            <ul class="features-list">
              <li>
                Liste de missions filtrées automatiquement selon votre profil.
              </li>
              <li>
                Détails complets avant acceptation&nbsp;: adresse, contact,
                contraintes <strong>chantier</strong>.
              </li>
              <li>
                Suivi de la <strong>livraison</strong> jusqu’à la remise, avec
                statut mis à jour en temps réel.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Étape 4 : Paiement -->
      <div class="livratos-row reverse">
        <div class="livratos-col">
          <div class="livratos-image-card">
            <img
              src="@/assets/pictures/billing-delivery.webp"
              alt="Paiement des missions réalisées par le livreur"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="livratos-col">
          <div class="livratos-text-card">
            <p class="badge">Étape 4 • Paiement</p>
            <h2>
              Des revenus regroupés,<br />
              un suivi clair de vos missions
            </h2>
            <p>
              Toutes vos <strong>livraisons</strong> réalisées via Livratos sont
              enregistrées dans votre espace <strong>livreur</strong>. Vos gains
              sont regroupés par période (8&nbsp;jours ou fin de mois) avec un
              récapitulatif détaillé des missions, des montants et des dates de
              versement. Vous savez exactement ce que vous avez fait, et ce que
              vous allez toucher.
            </p>
            <ul class="features-list">
              <li>
                Historique des missions et revenus disponibles dans votre
                tableau de bord.
              </li>
              <li>Paiements regroupés avec calendrier de versement lisible.</li>
              <li>
                Export possible pour votre comptabilité ou votre gestion
                freelance.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LivratosDoubleSectionLivreurs",
};
</script>

<style lang="scss" scoped>
.livratos-double-section {
  background-color: $background; // section blanche
  padding: 80px 20px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 60px;

    @media (min-width: 992px) {
      gap: 80px;
    }
  }

  .livratos-row {
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (min-width: 992px) {
      flex-direction: row;
      gap: 32px;
      align-items: stretch; // mêmes hauteurs
    }

    &.reverse {
      @media (min-width: 992px) {
        flex-direction: row-reverse;
      }
    }

    .livratos-col {
      flex: 1;
      display: flex; // pour étirer la card
      align-items: stretch;
    }

    /* CARD IMAGE (fond vert) */
    .livratos-image-card {
      background-color: $color-primary;
      border-radius: 16px;
      padding: 3px;
      width: 100%;
      box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18),
        0 6px 16px rgba(0, 0, 0, 0.12);

      display: flex;
      align-items: center;
      justify-content: center;

      @media (min-width: 992px) {
        padding: 22px;
      }

      img {
        width: 100%;
        border-radius: 12px;
        object-fit: cover;
        display: block;
      }
    }

    /* CARD TEXTE (fond noir, texte blanc) */
    .livratos-text-card {
      background-color: #000;
      border-radius: 16px;
      padding: 22px 22px 24px;
      width: 100%;
      color: #fff;
      box-shadow: 0 20px 45px rgba(0, 0, 0, 0.28), 0 8px 20px rgba(0, 0, 0, 0.2);

      @media (min-width: 768px) {
        padding: 26px 28px 30px;
      }

      .badge {
        display: inline-block;
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        padding: 0.25rem 0.8rem;
        border-radius: 999px;
        background: rgba($color-primary, 0.18);
        color: $color-primary;
        font-weight: 600;
        margin-bottom: 0.85rem;
      }

      h2 {
        font-size: 1.6rem;
        font-weight: 700;
        color: #ffffff;

        @media (min-width: 768px) {
          font-size: 2.1rem;
        }
      }

      p {
        margin-top: 1rem;
        font-size: 0.98rem;
        color: rgba(255, 255, 255, 0.85);

        @media (min-width: 768px) {
          font-size: 1.05rem;
        }
      }

      .features-list {
        margin-top: 1.1rem;
        padding-left: 0;
        list-style: none;

        li {
          position: relative;
          padding-left: 1.2rem;
          margin-bottom: 0.4rem;
          font-size: 0.95rem;
          color: rgba(255, 255, 255, 0.85);

          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0.55em;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background-color: $color-primary;
            transform: translateY(-50%);
            box-shadow: 0 0 0 2px rgba($color-primary, 0.25);
          }
        }
      }
    }
  }
}
</style>
